import { render, staticRenderFns } from "./PortalHistoryMenusPanel.vue?vue&type=template&id=1652d098&scoped=true&"
import script from "./PortalHistoryMenusPanel.vue?vue&type=script&lang=ts&"
export * from "./PortalHistoryMenusPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PortalHistoryMenusPanel.vue?vue&type=style&index=0&id=1652d098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652d098",
  null
  
)

export default component.exports